import React, { useCallback } from 'react';
import { Col, Row } from 'antd';
import { useInfiniteQuery } from 'react-query';
import LoadMoreButton from '../Button/LoadMoreButton';
import PastDeliveryOtpCard from '../PastDeliveryOtpCard/PastDeliveryOtpCard';
import { fetchPastDeliveryOtpsFromTransporter } from '../../api/deliveryOtps';
import styles from './PastDeliveryOtps.module.less';

export const PAST_DELIVERIES_OTPS_LIMIT = 20;

export const fetchPastOtpsKey = 'fetchPastOtpsInfiniteQuery';

const fetchPastOtpsTransporter = ({ pageParam = 0 }: { pageParam?: number }) => {
  return fetchPastDeliveryOtpsFromTransporter({
    start: pageParam * PAST_DELIVERIES_OTPS_LIMIT,
    limit: PAST_DELIVERIES_OTPS_LIMIT
  });
};

const PastDeliveryOtps = () => {
  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    fetchPastOtpsKey,
    fetchPastOtpsTransporter,
    {
      getNextPageParam: (lastGroup, groups) => {
        return lastGroup.length >= PAST_DELIVERIES_OTPS_LIMIT ? groups.length : undefined;
      }
    }
  );
  const loadMore = useCallback(() => fetchNextPage(), [fetchNextPage]);

  return (
    <Row gutter={[0, 16]}>
      {data &&
        data.pages.flat().map(otp => (
          <Col span={24} key={`${otp.otp}`}>
            <PastDeliveryOtpCard {...otp} />
          </Col>
        ))}
      {hasNextPage && (
        <Col span={24}>
          <LoadMoreButton onClick={loadMore} loading={isFetching} className={styles.loadMoreButton} />
        </Col>
      )}
    </Row>
  );
};

export default PastDeliveryOtps;
